import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

export const useFocusSkuHistorySelector = () => {
  const focusSkuHistoryData = useSelector((state) => state?.focusSkuHistory?.data) || {};
  const focusSkuHistoryLoading = useSelector((state) => state?.focusSkuHistory?.isLoading) || false;
  const focusSkuHistoryError = useSelector((state) => state?.focusSkuHistory?.error) || null;
  const prevLoadingRef = useRef(false);
  const prevLoading = prevLoadingRef.current;
  useEffect(() => {
    prevLoadingRef.current = focusSkuHistoryLoading;
  });
  return {
    historyData: focusSkuHistoryData,
    historyDataLoading: focusSkuHistoryLoading,
    historyDataError: focusSkuHistoryError,
    historyDataPrevLoading: prevLoading,
  };
}; 